(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phaf-mega-menu"] && !Shopify.designMode) return;
  try {
    class HeaderMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.closeTimer = null;

    this._open = this.open.bind(this);
    this._scheduleClose = this.scheduleClose.bind(this);
    this._cancelClose = this.cancelClose.bind(this);
    this._onOutside = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.panel = this.querySelector('.mega-menu__panel');
    this.trigger = document.querySelector('.js-open-mega');

    if (!this.trigger) return;

    this.trigger.addEventListener('mouseenter', this._open);
    this.trigger.addEventListener('mouseleave', this._scheduleClose);

    this.addEventListener('mouseenter', this._cancelClose);
    this.addEventListener('mouseleave', this._scheduleClose);

    document.addEventListener('click', this._onOutside);
  }

  open() {
    this.cancelClose();
    this.isOpen = true;
    this.classList.add('is-open');
    this.trigger?.setAttribute('aria-expanded', 'true');
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimer = setTimeout(() => {
      this.close();
    }, 200);
  }

  cancelClose() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  close() {
    this.isOpen = false;
    this.classList.remove('is-open');
    this.trigger?.setAttribute('aria-expanded', 'false');
  }

  handleOutsideClick(e) {
    if (!this.isOpen) return;
    if (!this.contains(e.target) && !this.trigger?.contains(e.target)) {
      this.close();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onOutside);
  }
}

if (!customElements.get('header-mega-menu')) {
  customElements.define('header-mega-menu', HeaderMegaMenu);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phaf-product-configurations"] && !Shopify.designMode) return;
  try {
    class PhafConfigurations extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
      const jsonScript = this.querySelector('.slides-json');

      try {
        this.slides = JSON.parse(jsonScript.textContent);
      } catch (e) {
        console.error('Invalid JSON in slides-json:', e);
        this.slides = [];
      }

      this.render();
      this.initSwiper();
    }

    renderRichText(obj) {
      if (!obj || !obj.children) return '';
      let html = '';
      obj.children.forEach((node) => {
        if (node.type === 'paragraph') {
          let text = '';
          node.children.forEach((child) => {
            if (child.type === 'text') text += child.value;
          });
          html += `<p>${text}</p>`;
        }
      });
      return html;
    }

    render() {
      const slideHTML = this.slides
        .map((slide) => {
          const rich = this.renderRichText(slide.description);

          return `
        <div class="swiper-slide">
          <div class="slide-inner">
             <h2 class="mobile-headline">${slide.main_title || ''}</h2>
            <div class="slide-image-wrap">
              <img src="${slide.image}" class="slide-image">
            </div>

            <div class="slide-text">
              <h2 class="desktop-headline">${slide.main_title || ''}</h2>
              <h3>${slide.subtitle || ''}</h3>
              <div class="slide-desc">${rich}</div>
            </div>
          </div>
        </div>
      `;
        })
        .join('');

      this.shadowRoot.innerHTML = `
  <style>


    .swiper {
  position: relative;
  overflow: hidden;
}

.mobile-headline{
    display: none;
}

.swiper-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: content-box;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: auto;
  box-sizing: border-box;
}

.swiper-vertical .swiper-wrapper {
  flex-direction: column;
}

.swiper-horizontal .swiper-wrapper {
  flex-direction: row;
}

    .wrapper {
      border-radius: 22px;
      overflow: hidden;
      background: #61B8AB;
      padding: 1em;
      margin-top: 3rem;
      color: #fff;
      position: relative;
    }

       .slide-text h2{
                margin: 0;
              font-size: 45px;
                  letter-spacing: 0;
          }

           .slide-text h3{
              font-size: 45px;
                  letter-spacing: 0;
                    margin: 0;
                   font-weight: 500;
           }

           .slide-desc{
            font-size: 16px;
    letter-spacing: 0;
           }

    /* ===== DESKTOP ===== */
    .desktop-swiper {
      height: 520px;
    }

    /* ===== MOBILE ===== */
    .mobile-swiper {
      display: none;
    }

    .swiper-slide {
      display: flex;
      align-items: center;
    }

    .slide-inner {
      display: grid;
      grid-template-columns: 60% 40%;
      gap: 2rem;
      width: 100%;
      align-items: center;
          padding: 0 3em;
    }

    .slide-image {
      width: 100%;
      max-height: 430px;
      object-fit: contain;
    }

    .desktop-pagination {
        position: absolute;
    z-index: 999999;
        right: 0;
            bottom: 5em;
                z-index: 999999;
    }

   .desktop-pagination .swiper-pagination-bullet {
      width: 3px !important;
      height: 5em !important;
      background: #ffffff57;
      display: block;
          margin: 1em 0;
   }

   .desktop-pagination .swiper-pagination-bullet-active{
    background: #fff !important;
   }

    @media (max-width: 768px) {
      .desktop-swiper {
        display: none;
      }

      .swiper-pagination.mobile-pagination{
          position: absolute;
          bottom: 2em;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1rem;
      }

      .swiper-pagination-bullet.swiper-pagination-bullet{
           width: 50px;
          background: #ffffff57;
          display: block;
          height: 3px;
      }

     .swiper-pagination-bullet.swiper-pagination-bullet-active{
       background: #ffff;
     }

      .slide-inner{
        padding: 0;
      }

      .mobile-headline{
    display: block;
        letter-spacing: -0.78px;
        font-size: 40px;
        line-height: 40px;
        font-weight: 500;
          margin-bottom: 0;
       padding: 0 1em;
}

      .desktop-headline{
        display: none;
      }

      .slide-text h3{
        letter-spacing: -0.78px;
        font-size: 40px;
        font-weight: 500;
             margin: 0;
      }

      .slide-text{
        padding-bottom: 4em;
      }

      .mobile-swiper {
        display: block;
      }

      .slide-desc{
          max-height: 10em;
    overflow: auto;
      }

      .wrapper {
        padding: 20px;
         border-radius: 0;
        
      }

      .slide-inner {
        grid-template-columns: 1fr;
        text-align: center;
        gap: 0;
      }

      .slide-image {
        max-height: 100%;
      }
          .slide-text h2{
                margin: 0;
          }
    
    }
  </style>

  <div class="wrapper">

    <!-- DESKTOP -->
    <div class="swiper desktop-swiper">
      <div class="swiper-wrapper">
        ${slideHTML}
      </div>
      <div class="swiper-pagination desktop-pagination"></div>
    </div>

    <!-- MOBILE -->
    <div class="swiper mobile-swiper">
      <div class="swiper-wrapper">
        ${slideHTML}
      </div>
      <div class="swiper-pagination mobile-pagination"></div>
    </div>

  </div>
  `;
    }

    initSwiper() {
      // Desktop – vertical
      this.desktopSwiper = new window.Swiper(this.shadowRoot.querySelector('.desktop-swiper'), {
        modules: [window.SwiperModules.Navigation, window.SwiperModules.Pagination, window.SwiperModules.Autoplay],
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        spaceBetween: 30,
        pagination: {
          el: this.shadowRoot.querySelector('.desktop-pagination'),
          clickable: true,
        },
      });

      // Mobile – horizontal
      this.mobileSwiper = new window.Swiper(this.shadowRoot.querySelector('.mobile-swiper'), {
        modules: [window.SwiperModules.Navigation, window.SwiperModules.Pagination, window.SwiperModules.Autoplay],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
          el: this.shadowRoot.querySelector('.mobile-pagination'),
          clickable: true,
        },
      });
    }
  }

  customElements.define('phaf-configurations', PhafConfigurations);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class SliderDots extends HTMLElement {
    constructor() {
      super();
      this.total = 0;
      this.dots = [];
      this.slider = null;
      this.track = null;
      this.slideWidth = 0;
      this._onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.total = Number(this.dataset.total || 0);
      if (this.total <= 1) return;

      this.renderDots();
      this.findSlider();
      this.bindEvents();
    }

    renderDots() {
      this.innerHTML = '';
      this.dots = [];

      for (let i = 0; i < this.total; i++) {
        const dot = document.createElement('span');
        dot.className = 'dot' + (i === 0 ? ' is-active' : '');
        this.appendChild(dot);
        this.dots.push(dot);
      }
    }

    findSlider() {
      // slider-component
      this.slider = this.closest('slider-component') || this.closest('.slider-buttons')?.closest('slider-component');

      if (!this.slider) {
        console.warn('[SliderDots] slider-component not found');
        return;
      }

      // actual scroll container
      this.track = this.slider.querySelector('.slider');

      if (!this.track) {
        console.warn('[SliderDots] slider track not found');
      }
    }

    bindEvents() {
      if (!this.slider || !this.track) return;

      // arrows
      this.slider.addEventListener('slideChanged', (e) => {
        const index = e.detail?.currentPage;
        if (typeof index === 'number') {
          this.setActive(index);
        }
      });

      // swipe / drag
      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      // initial calc
      this.calculateSlideWidth();
    }

    calculateSlideWidth() {
      const firstSlide = this.track.querySelector('.slider__slide');
      if (firstSlide) {
        this.slideWidth = firstSlide.offsetWidth;
      }
    }

    onScroll() {
      if (!this.slideWidth) {
        this.calculateSlideWidth();
        if (!this.slideWidth) return;
      }

      const index = Math.round(this.track.scrollLeft / this.slideWidth);
      this.setActive(index);
    }

    setActive(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this._onScroll);
    }
  }

  customElements.define('slider-dots', SliderDots);
  } catch(e) { console.error(e); }
})();

})();
